import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";
import useChangeCompany from "../../../../customHooks/useChangeCompany";

const ReplyFile = props => {
  const {
    item,
    myType,    
    onMove,
    onPreview
  } = props;
  const navigate = useNavigate();
  const answer = useSelector(state => state.ask.answer.detail);
  const companies = useSelector(state => state.company.companies);
  const attachment = useSelector(state => state.ask.attachment);

  const {changeCompanySelected} = useChangeCompany();

  return (
    <div
      key={"askAnswer-reply-file_" + Math.random()}
      className="askAnswer-reply-fileRow"
    >
      <div className="askAnswer-reply-fileRow-cols-file">
        <div className="askAnswer-reply-fileRow-cols-file-icon">
          <FontAwesomeIcon icon={["far", "file-alt"]} />
        </div>
        <div className="askAnswer-reply-fileRow-cols-file-name">
          {item.fileName}
        </div>
      </div>
      <div className="askAnswer-reply-fileRow-cols-actions">
        <div>
          {item.source === "dms" && (
            <div
              className="askAnswer-reply-fileRow-cols-actions-preview"
              onClick={() => onPreview(item.id)}
            >
              <Tooltip title="Anteprima documento" color={"rgb(0, 80, 117)"}>
                <FontAwesomeIcon icon={["far", "eye"]} onClick={() => {}} />
              </Tooltip>
            </div>
          )}
          {item.source === "dms" && myType === "STUDIO" ? (
            <div className="askAnswer-reply-fileRow-cols-actions-move">
              {attachment.isMovingDocument !== item.id ? (
                <Tooltip title="Sposta in archivio documenti" color={"rgb(0, 80, 117)"}>
                  <FontAwesomeIcon
                    icon={["far", "archive"]}
                    onClick={() => {
                      onMove(item.id, item.fileName);
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Spostamento in corso" color={"rgb(0, 80, 117)"}>
                  <FontAwesomeIcon icon={["far", "spinner"]} spin />
                </Tooltip>
              )}
            </div>
          ) : item.source !== "dms" ? (
            <div className="askAnswer-reply-fileRow-cols-actions-detail">
              <Tooltip title="Vai al dettaglio del documento" color={"rgb(0, 80, 117)"}>
                <FontAwesomeIcon
                  icon={["far", "arrow-right"]}
                  onClick={() => {
                    changeCompanySelected(companies.find(x => x.uuid === answer.itemId).id);
                    navigate(`/dettaglio-documento/${item.id}?ask-answer=${answer.id}`);
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ReplyFile;
